var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      height: 0,
      width: 0
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.293 12.95l0.707 0.707 5.657-5.657-1.414-1.414-4.243 4.242-4.243-4.242-1.414 1.414z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.050 9.293l-0.707 0.707 5.657 5.657 1.414-1.414-4.242-4.243 4.242-4.243-1.414-1.414z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.277 6.277a.948.948 0 0 1 1.234-.091l.106.091 5.053 5.053a.948.948 0 0 1 .092 1.234l-.092.106-5.053 5.053a.947.947 0 0 1-1.431-1.234l.091-.106L13.66 12 9.277 7.617a.948.948 0 0 1-.091-1.233l.091-.107Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.75a.75.75 0 0 1 .743.648l.007.102v4a.75.75 0 0 1-1.493.102L15.25 6.5v-4a.75.75 0 0 1 .75-.75Zm-8 0a.75.75 0 0 1 .743.648l.007.102v4a.75.75 0 0 1-1.493.102L7.25 6.5v-4A.75.75 0 0 1 8 1.75Zm13 7a.75.75 0 0 1 .102 1.493L21 10.25H3a.75.75 0 0 1-.102-1.493L3 8.75h18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3.75H5A2.75 2.75 0 0 0 2.25 6.5v13A2.75 2.75 0 0 0 5 22.25h14a2.75 2.75 0 0 0 2.75-2.75v-13A2.75 2.75 0 0 0 19 3.75ZM5 5.25h14c.69 0 1.25.56 1.25 1.25v13c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-13c0-.69.56-1.25 1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.013 12.478.117.007a1 1 0 1 1-.227 0l.11-.007Zm5 0 .117.007a1 1 0 1 1-.226 0l.11-.007Zm5 0 .117.007a1 1 0 1 1-.227 0l.11-.007Zm-9.999 4.001a1 1 0 1 1-.11.006l.11-.006Zm5 0a1 1 0 1 1-.11.006l.11-.006Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalogue",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.813 15.925H4.615c-.892 0-1.615.723-1.615 1.615v.923a2.539 2.539 0 0 0 2.537 2.539h12.925A2.538 2.538 0 0 0 21 18.464v-.924c0-.892-.723-1.615-1.615-1.615h-3.199c-.54 0-1.044.27-1.344.719l-.375.562a.23.23 0 0 1-.192.102h-4.55a.23.23 0 0 1-.192-.102l-.375-.562c-.3-.45-.805-.72-1.345-.72Zm-3.197 1.384h3.197c.078 0 .15.04.193.104l.375.561c.3.45.804.72 1.344.72h4.55c.54 0 1.045-.27 1.344-.72l.375-.562a.23.23 0 0 1 .192-.103h3.199a.23.23 0 0 1 .23.231v.924a1.153 1.153 0 0 1-1.153 1.153H5.537a1.153 1.153 0 0 1-1.152-1.154v-.923a.23.23 0 0 1 .23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.385 12.232c.35 0 .64.26.686.598l.006.094v3.693a.692.692 0 0 1-1.378.094l-.007-.094v-3.693c0-.382.31-.692.693-.692Zm-9.231-7.384a.692.692 0 0 1 .094 1.378l-.094.007H6.46a1.153 1.153 0 0 0-1.145 1.023l-.008.13v9.231a.692.692 0 0 1-1.378.094l-.006-.094v-9.23a2.538 2.538 0 0 1 2.354-2.532l.183-.007h3.694Zm3.494-1.845a1.347 1.347 0 0 0-1.417 1.354v4.506c.01.724.573 1.309 1.287 1.344a5.4 5.4 0 0 1 2.739.777c.22.133.496.133.717 0a5.371 5.371 0 0 1 2.713-.776A1.36 1.36 0 0 0 21 8.872v-4.52a1.345 1.345 0 0 0-.424-.985l-.106-.09a1.347 1.347 0 0 0-.767-.275h-.135l-.302.02a7.196 7.196 0 0 0-2.433.642l-.218.107-.218-.107a7.195 7.195 0 0 0-2.75-.661Zm5.967 1.384v4.438l-.266.01a6.724 6.724 0 0 0-2.565.676l-.17.087-.167-.087a6.756 6.756 0 0 0-2.585-.677l-.248-.01V4.389l-.039-.003c.96.037 1.879.301 2.695.77a.692.692 0 0 0 .69 0 5.811 5.811 0 0 1 2.394-.751l.261-.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.616 3.864c.35 0 .64.26.686.598l.006.094v5.836a.692.692 0 0 1-1.378.094l-.007-.094V4.556c0-.383.31-.692.693-.692Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 18a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM4.25 21a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.269 2.992A9.75 9.75 0 1 1 12 21.75a.75.75 0 0 1 0-1.5 8.25 8.25 0 1 0-8.25-8.252c.003.616.076 1.23.218 1.829a.75.75 0 0 1-1.46.346 9.561 9.561 0 0 1-.258-2.17V12a9.75 9.75 0 0 1 6.019-9.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.718 7.25a.75.75 0 0 1 .75.75v4.215l3.296 2.01a.75.75 0 1 1-.78 1.28l-3.656-2.229a.75.75 0 0 1-.36-.64V8a.75.75 0 0 1 .75-.75Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 5.3c.4-.4 1-.4 1.5 0l11.9 11.8a1.1 1.1 0 01-1.5 1.7v-.1L5.2 6.9c-.4-.4-.4-1.1 0-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 5.3a1.1 1.1 0 011.7 1.5h-.1L6.9 18.8a1.1 1.1 0 01-1.7-1.5h.1L17.1 5.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93zM11.016 6.984h1.969v6h-1.969v-6zM11.016 15h1.969v2.016h-1.969v-2.016z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228v0zM16 13c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye-closed",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.561 0.439c-0.586-0.586-1.535-0.586-2.121 0l-6.318 6.318c-1.623-0.492-3.342-0.757-5.122-0.757-6.979 0-13.028 4.064-16 10 1.285 2.566 3.145 4.782 5.407 6.472l-4.968 4.968c-0.586 0.586-0.586 1.535 0 2.121 0.293 0.293 0.677 0.439 1.061 0.439s0.768-0.146 1.061-0.439l27-27c0.586-0.586 0.586-1.536 0-2.121zM13 10c1.32 0 2.44 0.853 2.841 2.037l-3.804 3.804c-1.184-0.401-2.037-1.521-2.037-2.841 0-1.657 1.343-3 3-3zM3.441 16c1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 1.715 0.54 3.304 1.459 4.607l-1.904 1.904c-1.639-1.151-3.038-2.621-4.114-4.323z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 13.813c0-0.849-0.133-1.667-0.378-2.434l-10.056 10.056c0.768 0.245 1.586 0.378 2.435 0.378 4.418 0 8-3.582 8-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.938 9.062l-2.168 2.168c0.040 0.025 0.079 0.049 0.118 0.074 1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303-1.208 0-2.403-0.149-3.561-0.439l-2.403 2.403c1.866 0.671 3.873 1.036 5.964 1.036 6.978 0 13.027-4.064 16-10-1.407-2.81-3.504-5.2-6.062-6.938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7h-7c-1 0-1.8.8-1.8 1.8v1.6c.1.5.3 1 .7 1.2l2 1.6v3c0 1.3 1.4 2.2 2.6 1.6l1.6-.8h.1c.5-.4.9-1 .9-1.6v-2.2l2-1.6c.4-.3.6-.8.6-1.3V8.7c0-1-.7-1.7-1.7-1.7zm-7 1.5h7c.1 0 .3.1.3.3v1.5l-.1.2-2.4 1.7-.2.6v2.6l-.2.3-1.6.8c-.2 0-.4 0-.4-.3v-3.4c0-.2 0-.4-.2-.6l-2.4-1.7V8.7s0-.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.3c2.6 0 4.6 2 4.7 4.5V14a.7.7 0 01-1.4.1V7c0-1.7-1.4-3.1-3.1-3.2H7a3.3 3.3 0 00-3.2 3V17c0 1.7 1.3 3.1 3 3.2H13a.7.7 0 01.1 1.5H7c-2.6 0-4.6-2-4.7-4.5V7c0-2.6 2-4.6 4.5-4.7H17zM19.5 17.5a.8.8 0 011.1 1l-3 3a.8.8 0 01-1.2-1l3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.5c.2-.3.7-.3 1-.1l3 3a.8.8 0 01-1 1.2l-3-3a.8.8 0 010-1.1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 15.5a.75.75 0 0 1 .75-.75h2.31a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.259 11.25a.75.75 0 0 1 .75-.75h1.15a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0V12h-.4a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.85,
    cy: 8.25,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-news",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 10a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM11.25 7a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM6.75 7.75v1.5h1.5v-1.5h-1.5Zm-1.5-.25c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25v-2ZM5.25 13.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM5.25 17a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.75A1.25 1.25 0 0 0 3.75 5v14A1.25 1.25 0 0 0 5 20.25h12.25V5A1.25 1.25 0 0 0 16 3.75H5Zm13.75 3.5V5A2.75 2.75 0 0 0 16 2.25H5A2.75 2.75 0 0 0 2.25 5v14A2.75 2.75 0 0 0 5 21.75h14A2.75 2.75 0 0 0 21.75 19v-9A2.75 2.75 0 0 0 19 7.25h-.25Zm0 1.5v11.5H19A1.25 1.25 0 0 0 20.25 19v-9A1.25 1.25 0 0 0 19 8.75h-.25Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-reload",
    viewBox: "-4 -4 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.802 5.197c-2.925-3.194-7.13-5.197-11.803-5.197-8.837 0-16 7.163-16 16h3c0-7.18 5.82-13 13-13 3.844 0 7.298 1.669 9.678 4.322l-4.678 4.678h11v-11l-4.198 4.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 16c0 7.18-5.82 13-13 13-3.844 0-7.298-1.669-9.678-4.322l4.678-4.678h-11v11l4.197-4.197c2.925 3.194 7.13 5.197 11.803 5.197 8.837 0 16-7.163 16-16h-3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-success",
    viewBox: "-2 -2 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11l2-2 5 5 11-11 2 2-13 13z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "-2 -2 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.899l13.409 26.726h-26.819l13.409-26.726zM16 0c-0.69 0-1.379 0.465-1.903 1.395l-13.659 27.222c-1.046 1.86-0.156 3.383 1.978 3.383h27.166c2.134 0 3.025-1.522 1.978-3.383h0l-13.659-27.222c-0.523-0.93-1.213-1.395-1.903-1.395v0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2s2 0.895 2 2v6c0 1.105-0.895 2-2 2z"
  })))));
}
export default SvgIcons;